import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import LayoutRoutes from "./LayoutRoutes";
import PrivateRoutes from "./PrivateRoutes";
import SignIn from "../Auth";
import ForgotPassword from "../Pages/Auth/ForgotPassword";
import { useAuth } from "../Context/AuthContext";

export default function Routers() {
  const { user, isLoading } = useAuth();
  const login = localStorage.getItem("login") === "true" || !!user;

  if (isLoading) {
    return (
      <div className="loader-wrapper">
        <div className="loader">
          <span></span><span></span><span></span><span></span><span></span>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Redirect root route based on login */}
      <Route
        path="/"
        element={
          login ? (
            <Navigate to={`${process.env.PUBLIC_URL}/dashboard`} replace />
          ) : (
            <Navigate to={`${process.env.PUBLIC_URL}/login`} replace />
          )
        }
      />

      {/* Public routes - redirect to dashboard if already logged in */}
      <Route
        path={`${process.env.PUBLIC_URL}/login`}
        element={
          login ? (
            <Navigate to={`${process.env.PUBLIC_URL}/dashboard`} replace />
          ) : (
            <SignIn />
          )
        }
      />
      <Route
        path={`${process.env.PUBLIC_URL}/forgot-password`}
        element={
          login ? (
            <Navigate to={`${process.env.PUBLIC_URL}/dashboard`} replace />
          ) : (
            <ForgotPassword />
          )
        }
      />

      {/* Protected routes */}
      <Route path="/" element={<PrivateRoutes />}>
        <Route path="/*" element={<LayoutRoutes />} />
      </Route>

      {/* Catch-all route for undefined paths */}
      <Route
        path="*"
        element={
          login ? (
            <Navigate to={`${process.env.PUBLIC_URL}/dashboard`} replace />
          ) : (
            <Navigate to={`${process.env.PUBLIC_URL}/login`} replace />
          )
        }
      />
    </Routes>
  );
}
